import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';

/** GRO-3284 — side-by-side model comparison viewed (control = false, treatment = true). */
export function trackNoteComparisonViewed(
  isComparison: boolean,
  sessionId: string | undefined
): void {
  track({
    event_name: TrackingEventName.NoteComparisonViewed,
    props: {
      is_comparison: isComparison,
      session_id: sessionId,
    },
    options: { amplitude: true },
  });
}
